import React from 'react';

import logEvent from '~/util/analytics';
import GetTheAppLinks from '~/constants/GetTheAppLinks';
import StyledComponent from '~/components/Styled/Styled';
import css from '~/components/NCAABTournamentLanding/NCAABTournamentLanding.scss';

const onClick = logEvent.bind(this, 'conversion', {
  type: 'bixby_landing_reviews',
  campaign: 'thescoreapp',
});

// eslint-disable-next-line react/prefer-stateless-function
class NCAABTournamentLanding extends React.PureComponent {
  render() {
    return (
      <div className={css.container}>
        <div className={css.text}>
          Our app is the best way to follow the NCAA Basketball Tournament!
        </div>
        <div className={css.cta}>
          <img
            src="/static/images/ncaab-device.png"
            srcSet="/static/images/ncaab-device@2x.png 2x,
					 /static/images/ncaab-device@3x.png 3x"
            alt=""
            className={css.phone}
          />
          <div className={css.getTheAppContainer}>
            <a href={GetTheAppLinks.ncaab_bracket_link}>
              <button className={css.getTheAppButton} onClick={onClick}>
                Get the app
              </button>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

NCAABTournamentLanding.displayName = 'NCAABTournamentLanding';

export default StyledComponent(NCAABTournamentLanding, [css]);
